import PageHero from "@/components/PageHero";
import { LegalSection, LegalNote } from "@/components/Legal";
import useSEO from "@/hooks/useSEO";
import { COMPANY } from "@/data/content";

const Terms = () => {
  useSEO(
    "Terms & Conditions — SSDE LTD",
    "The terms governing use of the SSDE LTD website and the provision of design services."
  );
  return (
    <>
      <PageHero
        testId="terms-hero"
        eyebrow="Legal"
        titleLines={["Terms &", "Conditions."]}
        lede={`The terms that govern the use of this website and design services provided by ${COMPANY.name}.`}
      />
      <section className="bg-offwhite py-16 sm:py-24" data-testid="terms-content">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 space-y-8">
          <LegalNote />
          <LegalSection title="1. About These Terms" testId="terms-about">
            <p>
              These terms apply to your use of the SSDE LTD website and to design
              services provided by SSDE LTD, registered at {COMPANY.address}.
              Specific project terms will be agreed in writing before any work begins.
            </p>
          </LegalSection>
          <LegalSection title="2. Our Services" testId="terms-services">
            <p>
              SSDE LTD provides specialised design services including graphic design,
              logo design, branding and visual identity, brochures and marketing
              materials, packaging design, website layout design, user interface
              design and digital content creation. Portfolio pieces shown on this
              website that are labelled as concepts are illustrative works and do not
              represent commissioned client projects.
            </p>
          </LegalSection>
          <LegalSection title="3. Quotations & Payment" testId="terms-payment">
            <p>
              Fees for design work are quoted per project and confirmed in writing
              before work commences. Payment terms, including any deposit required,
              will be set out in the individual project agreement.
            </p>
          </LegalSection>
          <LegalSection title="4. Intellectual Property" testId="terms-ip">
            <p>
              Unless agreed otherwise in writing, copyright in design work transfers
              to the client upon receipt of full payment. SSDE LTD retains the right
              to display completed work in its portfolio unless confidentiality is
              agreed in advance.
            </p>
          </LegalSection>
          <LegalSection title="5. Website Content" testId="terms-content">
            <p>
              The content of this website is provided for general information. While
              we take care to keep it accurate, it does not constitute professional
              advice, and we reserve the right to update it at any time.
            </p>
          </LegalSection>
          <LegalSection title="6. Liability" testId="terms-liability">
            <p>
              Nothing in these terms excludes or limits liability where it would be
              unlawful to do so. Otherwise, our liability in connection with this
              website is limited to the fullest extent permitted by law.
            </p>
          </LegalSection>
          <LegalSection title="7. Governing Law" testId="terms-law">
            <p>
              These terms are governed by the laws of England and Wales, and any
              disputes are subject to the jurisdiction of the courts of England and
              Wales.
            </p>
            <p className="text-xs text-charcoal/50">Last updated: July 2026</p>
          </LegalSection>
        </div>
      </section>
    </>
  );
};

export default Terms;
